// firebase/firebase.js
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
  indexedDBLocalPersistence
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { Capacitor } from '@capacitor/core';

// ============================================
// PLATFORM DETECTION
// ============================================
const isNative = Capacitor.isNativePlatform();

console.log('📱 Platform:', isNative ? 'Native (iOS/Android)' : 'Web Browser');

// ============================================
// FIREBASE CONFIGURATION (Platform-Specific)
// ============================================
const firebaseConfig = isNative ? {
  // iOS/Android Native App Config
  apiKey: "AIzaSyB18hMx3CfbNYHuC3n76T3D_eU1BRzY4Fw",
  authDomain: "fir-7c9c9.firebaseapp.com",
  projectId: "fir-7c9c9",
  storageBucket: "fir-7c9c9.firebasestorage.app",
  messagingSenderId: "53637039038",
  appId: "1:53637039038:ios:1397131f159f5c808f6fef"
} : {
  // Web Browser Config
  apiKey: "AIzaSyAoO2xpKm_002y9ydbPPBH5hbBIVbFnmgU",
  authDomain: "fir-7c9c9.firebaseapp.com",
  projectId: "fir-7c9c9",
  storageBucket: "fir-7c9c9.firebasestorage.app",
  messagingSenderId: "53637039038",
  appId: "1:53637039038:web:24b0e0ac0f8f87178f6fef",
  measurementId: "G-20HST2QZKE"
};

// ============================================
// INITIALIZE FIREBASE APP
// ============================================
console.log('🔥 Initializing Firebase...');
const app = initializeApp(firebaseConfig);

// ============================================
// INITIALIZE SERVICES
// ============================================
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

// ============================================
// SETUP AUTH PERSISTENCE
// ============================================
// Use different persistence strategies for web vs mobile
const persistenceType = isNative ? indexedDBLocalPersistence : browserLocalPersistence;

setPersistence(auth, persistenceType)
  .then(() => {
    console.log(`✅ Auth persistence enabled (${isNative ? 'IndexedDB' : 'LocalStorage'})`);
  })
  .catch((error) => {
    console.error('❌ Failed to set auth persistence:', error);
  });

// ============================================
// INITIALIZE FIREBASE CLOUD MESSAGING (WEB ONLY)
// ============================================
let messaging = null;

// Only initialize FCM for web browsers (not native mobile)
if (!isNative && typeof window !== 'undefined' && 'Notification' in window) {
  try {
    messaging = getMessaging(app);
    console.log('✅ Firebase Cloud Messaging initialized');
  } catch (error) {
    console.warn('⚠️ FCM not supported in this browser:', error.message);
  }
}

// ============================================
// GOOGLE AUTH PROVIDER CONFIGURATION
// ============================================
// Force account selection every time (optional - improves UX)
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// ============================================
// EXPORTS
// ============================================
export { 
  app,
  auth, 
  db, 
  storage, 
  googleProvider,
  messaging 
};

// Legacy export for backward compatibility
export const firestore = db;

console.log('✅ Firebase initialized successfully');
console.log('   Platform:', isNative ? 'Native Mobile' : 'Web Browser');
console.log('   Auth Domain:', firebaseConfig.authDomain);
console.log('   Project ID:', firebaseConfig.projectId);
console.log('   API Key:', firebaseConfig.apiKey.substring(0, 10) + '...');